<template>
  {{ $t('service.list') }} <BookmarkIcon class="w-4 h-4 ml-2 mr-2" />
  <LoadingIcon icon="three-dots" class="w-8 h-8" v-show="loading" />
  <ul v-show="!loading">
    <template v-for="service in services" :key="service.uuid">
      <li v-if="this.selectedServices.includes(service.uuid)">
        <router-link :to="{ name: 'side-menu-services-detail', params: { uuid: service.uuid } }" tag="a">
          <ArrowUpLeftIcon class="w-4 h-4 mr-1 ml-2" /> {{ service.name.sk_SK }}
        </router-link>
      </li>
    </template>
  </ul>
</template>

<script>
import { defineComponent } from 'vue'
import serviceApi from '../../services/services/service.api'

export default defineComponent({
  data() {
    return {
      services: [],
      loading: true
    }
  },
  mounted() {
    serviceApi.getList(1, 100).then(
      response => {
        this.services = response.data.data
        this.loading = false
      },
      error => {
        console.log(error)
        this.loading = false
      }
    )
  },
  props: {
    selectedServices: {
      type: Array,
      default: () => []
    }
  }
})
</script>
